<ion-app>
  <ion-router-outlet id="public-main-content">
    
  </ion-router-outlet>
  <menu-client-support-login [isLoggedIn]="false"></menu-client-support-login>
</ion-app>


